export default __webpack_public_path__ + "static/media/icon_up.867df6ba.svg";